import { render, staticRenderFns } from "./EmailTemplateUpload.vue?vue&type=template&id=0145f0a8&"
import script from "./EmailTemplateUpload.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports